<main class="w-full">
	<label
		class="component-field-input-text-rounded show"
		[class.itr-chosed]="isChosed"
		[class.itr-labeled]="isLabeled"
		[class.itr-tabeled]="isTabeled"
		[class.itr-disabled]="isDisabled"
		[class.itr-touched]="isTouched || !dataInput?.editLabel"
		[class.itr-error]="hasError"
		[class.itr-valid]="isValidIcon"
		[class.itr-progress]="dataInput?.progress || !dataInput?.editLabel"
		[class.itr-required]="isRequired"
		[class.progress-loaded]="dataInput?.motionCompleteDataSend"
	>
		@if (!dataInput?.editLabel) {
			<div class="progress-container" [class.justify-end]="dataInput?.motionCompleteDataSend">
				<div
					class="progress-bar upload-bar"
					[class.progress-loaded]="dataInput?.motionCompleteDataSend"
					[style.width.%]="dataInput?.progress"
				></div>
			</div>
		}

		<div
			class="flex flex-row transition duration-200 ease-in-out"
			[class.dataEnable]="dataInput?.editLabel"
			[class.dataDisable]="!dataInput?.editLabel"
		>
			<section class="itr-section-icon w-6"></section>

			<section class="itr-section-body">
				@if (!isTabeled) {
					<p class="itr-label">{{ labelValue }}</p>
				}
				<input
					#inputData
					[disabled]="isDisabled || isTabeled"
					[readonly]="isReadOnly"
					class="itr-input"
					[class.text-center]="isReadOnly"
					type="text"
					(focus)="focusIn()"
					(blur)="focusOut()"
					[placeholder]="placeholder"
					(keyup)="inputKeyUpEvent($event)"
				/>

				<div
					class="itr-focus-marker"
					[class.opacity-0]="isReadOnly"
					[class.cursor-default]="isReadOnly"
					[class.itr-errorFeed]="errorFeed"
				>
					&nbsp;
				</div>
			</section>
			@if (componentFilling) {
				<span
					class="transition duration-400 ease-in-out"
					[ngStyle]="{ width: componentFilling }"
				></span>
			}
			@if (!componentFilling && (hasError || isValidIcon)) {
				<section class="itr-section-icon">
					<div class="icon-box itr-icon-validation"></div>
				</section>
			}
			@if (inputComponetHelperIconStyle && !isTabeled) {
				<section class="itr-section-icon">
					<div [class]="'icon-box ' + inputComponetHelperIconStyle"></div>
				</section>
			}
			@if (isLabeled && isEditable) {
				<section class="if-section-icon">
					<lbca-icon name="lucide:pencil" size="small" class="size-2.5 text-primary"></lbca-icon>
				</section>
			}
			@if (maskIcon && !isLabeled) {
				<section class="itr-section-icon">
					<div [class]="'icon-box itr-icon-mask ' + maskIcon"></div>
				</section>
			}
			@if (inputComponetIconStyle && !isTabeled) {
				<section
					class="itr-section-icon"
					(click)="!isReadOnly && !isLoading && confirmAction($event)"
				>
					@if (inputComponetIconStyle !== 'button-ok' && !isLoading) {
						<div
							[ngClass]="{
								'icon-box': inputComponetIconSize === 'normal',
								'icon-box-sm': inputComponetIconSize === 'sm',
								'icon-box-lg ': inputComponetIconSize === 'lg',
								'bg-primary': hasError === false && !isReadOnly,
								'bg-error': hasError === true && !isReadOnly,
								'cursor-pointer': !isReadOnly
							}"
							[class]="inputComponetIconStyle"
						></div>
					}
					@if (inputComponetIconStyle === 'button-ok') {
						<div
							class="w-8 rounded-full bg-gray-50 flex justify-center items-center"
							[class.text-primary]="!hasError"
							[class.text-error]="hasError"
						>
							OK
						</div>
					}
					@if (isLoading) {
						<div>
							<img class="forgot-loading" src="./assets/icons/loading-points-bg-1.svg" />
						</div>
					}
				</section>
			}
			@if (helperTextValue && !isLabeled && !isTabeled) {
				<p class="itr-helper" title="{{ helperTextValue }}">
					{{ helperTextValue }}
				</p>
			}
		</div>
	</label>
</main>

<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<div class="emojis-happy icon-box ml-[16px]"></div>
	</div>
</ng-template>
